import React, { useEffect, useState, useContext } from "react"
import { apiEndpoint } from "helpers/url_helper";

import { Link } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { VehicleDataContext } from "components/Common/PageDataContext";
import {
    Col,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import VehicleDetailsTemplate from "../../assets/templates/VehicleDetailTemplate.csv"
const btnstylesObj = {
    "margin-left": '43%',
  };

const UploadVehicleDataModalComponent = (props) => {
    const [file, setFile] = useState();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [alertmsg, setAlert] = useState();

    const toggle = () => {

        setModalIsOpen(!modalIsOpen)
      }

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const handleVehicleDataUploadClick = () => {
        if (!file) {
            setAlert(
                <ReactBSAlert
                  warning
                  title="Please select file!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
              )
            return;
        }

        var formdata = new FormData();
        console.log("CampusSelected--->",props.campus);
        formdata.append("VehicleDataFile",file);
        formdata.append("CampusID",props.campus.value);
        formdata.append("Token",sessionStorage.getItem("Clear_AuthUser"));
        setAlert(
            <ReactBSAlert
              info
              title="Please wait while uploading the file!"
              onConfirm={() => setAlert(null)}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="info"
            >
            </ReactBSAlert>
          )
        //alert("Uploaded");
        // can't change
        fetch(apiEndpoint+'/UploadVehicleDataExcel', {
            method: 'POST',
            body: formdata,
            // body: file,
            // 👇 Set headers manually for single file upload
            // headers: {
            //     'content-type': file.type,
            //     'content-length': `${file.size}`, // 👈 Headers need to be a string
            // },
        })
            .then((res) => res.json())
            .then((result) => {
                if (result != undefined) {
                    console.log(result);
                    if (result.NoOfRowsAffected != undefined && result.NoOfRowsAffected != 0) {
                      setAlert(
                        <ReactBSAlert
                          success
                          title="Data Saved Successfully!"                         
                          onConfirm={() => setAlert(null)}
                          onCancel={() => setAlert(null)}
                          confirmBtnBsStyle="info"
                        >
                            No of records Updated: {result.NoOfRowsAffected}
                        </ReactBSAlert>
                      )
                      window.location.reload(false);
                    }
                    else if(result.NoOfRowsAffected== 0){
                        setAlert(
                            <ReactBSAlert
                              info                       
                              onConfirm={() => setAlert(null)}
                              onCancel={() => setAlert(null)}
                              confirmBtnBsStyle="info"
                            >
                                No of records Updated: {result.NoOfRowsAffected}
                            </ReactBSAlert>
                          )
                    }

                    else {
                        setAlert(
                          <ReactBSAlert
                            warning
                            title="Something went wrong!"
                            onConfirm={() => setAlert(null)}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="warning"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                      }
                }
            })
            .catch((err) => console.error(err));
    };

    const handleTemplateDownloadClick = () => {
        alert("Downloaded");
    };

    return (
        <>
            <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                onClick={toggle}>
                      <i className="ti-upload font-size-17"/>
                </Link>
            {modalIsOpen == true && alertmsg}
            <Modal isOpen={modalIsOpen} style={{ maxWidth: "30%" }}>

                <ModalHeader toggle={toggle} tag="h4">
                    Upload Vehicle Data
                </ModalHeader>
                <ModalBody>
                    <AvForm className="needs-validation">
                        <Row>
                            <Col md={9}>
                                <AvField
                                    name="vrFileUploadid"
                                    placeholder="Browse"
                                    type="file"
                                    className="form-control"
                                    id="vrFileUploadid"
                                    onChange={handleFileChange}
                                />
                                {/* <div>{file && `${file.name} - ${file.type}`}</div> */}
                            </Col>
                            <Col md={3} >
                                <Link className=" form-control btn btn-primary waves-effect waves-light"
                                    to="#" role="Button" id="uploadBtn" onClick={() => {
                                        handleVehicleDataUploadClick();
                                        //toggle();
                                    }}>Upload</Link>
                            </Col>
                        </Row>
                    </AvForm>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col md={12} >
                            <a href={VehicleDetailsTemplate} download="VehicleDetailTemplate.csv" target='_blank'>Download Template</a>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </>
    )
}


export default UploadVehicleDataModalComponent;